import React, { useEffect, useState } from 'react';
import SelectSearch, { fuzzySearch } from "react-select-search";
import BootstrapTable from 'react-bootstrap-table-next';
import '../style/custom.css';
import configData from '../configData.json';
import Spinner from 'react-bootstrap/esm/Spinner';

export default function TransportationPopup(props) {
    const [carrierDetails, setCarrierDetails] = useState([]);
    const [countries, setCountries] = useState([{ value: 0, name: "-- Select A Value --" }]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [countryLoading, isCountryLoading] = useState(false);

    const [selectedCity, setSelectedCity] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [selectedPostal, setSelectedPostal] = useState('');
    const [selectedName, setSelectedName] = useState('');
    const [selectedScac, setSelectedScac] = useState('');
    const [loading, setLoading] = useState(false);

    const [selectedItems, setSelectedItems] = useState([]); // State to track selected items

    const handleItemSelect = (row, isSelected) => {
        setSelectedItems(prevSelectedItems => {
            if (isSelected) {
                return [...prevSelectedItems, row]; // Add the selected item to the state
            } else {
                return prevSelectedItems.filter(item => item.id !== row.id); // Remove the deselected item from the state
            }
        });

        row.checked = isSelected;

    };

    const selectColumn = {
        dataField: 'select',
        text: 'Select',
        headerStyle: { width: '50px', textAlign: 'center' },
        formatter: (cell, row) => (
            <input
                type="checkbox"
                checked={row.checked}
                onChange={(e) => handleItemSelect(row, e.target.checked)}
            />
        )
    };

    const onCountrySelect = (e) => {
        debugger;
        if (e === 0) {
            setSelectedCountry("");
        } else {
            setSelectedCountry(e);
            LoadCityState(selectedPostal, e);
        }
    };

    const LoadCarrierData = async () => {
        debugger;
        setLoading(true);
        setCarrierDetails([]);

        const URL = `${configData.BASE_APP_URL}Carrier/GetCarrierSearch`;
        const requestBody = {
            name: selectedName,
            scaccode: selectedScac,
            countrycode: selectedCountry,
            postal: selectedPostal
        };

        await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify(requestBody)
        })
            .then(resp => resp.json())
            .then(resp => {
                setCarrierDetails(resp);

                if (resp.length > 0) {
                    // Filter selectedItems based on new search results
                    const updatedSelectedItems = selectedItems.filter(item => resp.some(result => result.id === item.id));
                    setSelectedItems(updatedSelectedItems);
                }
            });

        setLoading(false);
    }


    const LoadCountries = async () => {
        // debugger;
        isCountryLoading(true);
        const countryUrl = `${configData.BASE_APP_URL}Carrier/GetCountries`;
        await fetch(countryUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let countryOptions = [];
                resp.map(country => {
                    const own = {
                        "name": country.countryName,
                        "value": country.countryCode
                    }
                    countryOptions = [...countryOptions, own];
                })
                const defaultCountry = {
                    "name": "--Select A Value--",
                    "value": 0
                }
                countryOptions.unshift(defaultCountry);
                setCountries(countryOptions)
            })
        isCountryLoading(false);

        // setIsDisabled(props.isDisabled);
    }

    const LoadCityState = async (PostalCode, CountryCode) => {
        debugger;
        const trimmedPostalCode = PostalCode.trim(); // Trim the PostalCode

        if (trimmedPostalCode.length === 0) {
            // PostalCode is empty, handle the case accordingly
            setSelectedCity('');
            setSelectedState('');
            return;
        }

        if (CountryCode === '0') {
            // CountryCode is 0, handle the case accordingly
            setSelectedCity('');
            setSelectedState('');
            return;
        }

        const cistyStateUrl = `${configData.BASE_APP_URL}Carrier/GetCityState/${PostalCode}/${CountryCode}`;
        await fetch(cistyStateUrl, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                const cityState = resp; // Assuming the response contains a single record
                if (cityState.city != null) {
                    setSelectedCity(cityState.city); // Set the selected city value
                    setSelectedState(cityState.state); // Set the selected state value
                }
                else {
                    setSelectedCity('');
                    setSelectedState('');
                }
            });
    }

    const handlePostalBlur = () => {
        debugger;
        LoadCityState(selectedPostal, selectedCountry);
    };

    const handlePostalChange = (event) => {
        setSelectedPostal(event.target.value);
    };

    const handleNameChange = (event) => {
        setSelectedName(event.target.value);
    };

    const handleScacChange = (event) => {
        setSelectedScac(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault(); // Prevent the default form submission behavior

        if (selectedName.trim() === "" && selectedScac.trim() === "" && selectedPostal.trim() === "") {
            document.getElementById("error").innerHTML = "Please enter at least a single character to search on in Transportation Provider's Zip, Name or SCAC search boxes.";
            return;
        }
        else if (selectedPostal.trim() !== "" && selectedCountry.trim() === "") {
            document.getElementById("error").innerHTML = "Transportation Provider's country is required to proceed with the search if the Zip Code is provided.";
            return;
        }
        else
        {
            document.getElementById("error").innerHTML = "";
        }

        // Perform the desired action here, such as calling an API or updating the state

        LoadCarrierData();
    };

    useEffect(() => {
        LoadCountries();
        // LoadCustomer();
        // console.log("Selected Items:", selectedItems);
    }, [])

    // useEffect(() => {
    //     // LoadCustomer();
    //     // console.log("Selected Items:", selectedItems);
    // }, [selectedItems])

    const handleSelect = () => {
        // Call the onSelectedItems prop and pass the selected items
        // debugger;
        if (selectedItems.length === 0) {
            document.getElementById("error").innerHTML = "Please select at least one Transportation Provider";
            return;
        }
        // console.log(selectedItems);
        props.onSelectedItems(selectedItems);
    };


    const tpcolumns = [
        selectColumn,
        {
            dataField: 'carrierAddress1',
            text: 'Address',
            headerStyle: { width: '200px', textAlign: 'center' },
            align: 'center'

        },
        {
            dataField: 'carrierCity',
            text: 'City',
            headerStyle: { width: '100px', textAlign: 'center' },
            align: 'center'
        },
        {
            dataField: 'carrierState',
            text: 'State',
            headerStyle: { width: '100px', textAlign: 'center' },
            align: 'center'
        },
        {
            dataField: 'carrierZip',
            text: 'Postal',
            headerStyle: { width: '100px', textAlign: 'center' },
            align: 'center'
        },
        {
            dataField: 'carrierCountryName',
            text: 'Country',
            headerStyle: { width: '100px', textAlign: 'center' },
            align: 'center'
        },
        {
            dataField: 'carrierName',
            text: 'Name',
            headerStyle: { width: '300px', textAlign: 'center' },
            align: 'center'
        },
        {
            dataField: 'carrierSCACCode',
            text: 'SCAC',
            headerStyle: { width: '50px', textAlign: 'center' },
            align: 'center'
        },
        {
            dataField: 'carrierAddress2',
            text: 'Address2',
            headerStyle: { width: '150px', textAlign: 'center' },
            align: 'center'
        }
    ]

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div id="error" className="text-danger"></div>
                <div className='row'>

                    <div className="col-4 ps-1 form-field">
                        <label className='fw-bold'>Name</label>
                        <div>
                            <input className='form-control form-control-sm' type='text' onChange={handleNameChange} />
                        </div>

                    </div>
                    {countryLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" style={{ top: '1%', zIndex: '10' }} /> : countryLoading}
                    <div className="col-4 ps-1 form-field">
                        <label className='fw-bold'>Country</label>
                        <div>
                            <SelectSearch
                                id="ddnCountry"
                                name="ddnCountry"
                                value={selectedCountry}
                                options={countries}
                                onChange={onCountrySelect}
                                search
                                filterOptions={fuzzySearch}
                            >
                            </SelectSearch>
                        </div>

                    </div>

                    <div className="col-4 ps-1 form-field">
                        <label className='fw-bold'>Postal</label>
                        <div>
                            <input className='form-control form-control-sm' type='text' onBlur={handlePostalBlur} onChange={handlePostalChange} />
                        </div>

                    </div>

                </div>

                <div className='row mt-1'>

                    <div className="col-4 ps-1 form-field">
                        <label className='fw-bold'>SCAC</label>
                        <div>
                            <input className='form-control form-control-sm' type='text' onChange={handleScacChange} />
                        </div>

                    </div>

                    <div className="col-4 ps-1">
                        <label className='fw-bold'>City</label>
                        <div>
                            <label>{selectedCity}</label>
                        </div>



                    </div>

                    <div className="col-4 ps-1">
                        <label className='fw-bold'>State</label>
                        <div>
                            <label>{selectedState}</label>
                        </div>

                    </div>

                </div>
                {loading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : loading}
                <div className='row mt-2'>
                    <div className='col-12 px-1'>
                        <div className='main-table-text popup-table'>
                            <BootstrapTable
                                classes='table table-striped table-hover table-width'
                                headerClasses='table-top'
                                keyField="id"
                                bootstrap4
                                data={carrierDetails}
                                columns={tpcolumns}
                            />

                        </div>

                    </div>
                </div>
                <div className='text-center mt-1'>
                    <button type="submit" className="btn btn-filter ms-2">Search</button>
                    <button type="button" className="btn btn-filter ms-2" onClick={handleSelect}>Select</button>
                    <button type="button" className="btn btn-clear ms-2" onClick={props.onCancel}>Cancel</button>
                </div>
            </form>
        </>
    )
}
